export const config = {
  title: "Goldsmiths RV Repair",
  meta: {
    description:
      "Goldsmiths RV Repair offers expert RV and trailer maintenance—electrical, plumbing, slide‑outs, inspections & mobile service—in Tavares, FL.",
    keywords: [
      "Goldsmiths RV Repair",
      "RV service Tavares",
      "mobile RV repair FL",
      "RV inspection Tavares",
      "trailer repair Florida"
    ],
    author: "Goldsmiths RV Repair",
    canonicalUrl: "https://goldsmithsrvrepairs.com/",
  },
  sections: {
    header: { businessName: "Goldsmiths RV Repair" },
    sectionB: {
      heroTitle: "Goldsmiths RV Repair",
      heroSubtitle: "Mobile & Shop RV Repair in Tavares, FL",
      learnAboutText: "See Our Services",
      phoneNumber: "4073942658",
      phoneLabel: "(407) 394‑2658",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/1336865688/photo/maintaining-my-recreational-vehicle.jpg?s=612x612&w=0&k=20&c=iPdfznhGhLR250rB4Q7EDGkflEhQd5rmr57OAjH584w=",
      cardData: [
        {
          title: "Mobile & In‑Shop Repair",
          description:
            "Electrical, plumbing, slide‑outs & more, onsite or at our Tavares shop.",
        },
        {
          title: "45‑Point Inspection",
          description:
            "Thorough inspections for buyers, sellers, or routine maintenance.",
        },
        {
          title: "Appliance & Trailer Repair",
          description: "Trailer systems, horse trailers—repair and upgrades.",
        },
      ],
      description:
        "Serving Lake County and Central Florida, Goldsmiths RV Repair LLC keeps your RV and trailers road-ready with expert service, inspections and fast mobile or shop repairs.",
    },
    sectionC: {
      servicesTitle: "Our Services",
      servicesDescription:
        "Comprehensive RV and trailer repair—including slide‑outs, roof, appliances, inspections, brakes, bearings & plumbing.",
      cards: [
        {
          title: "Slide‑out & Roof Repair",
          description: "Fix leaks, roof damage and slide‑out mechanisms.",
          imageSrc: "https://media.istockphoto.com/id/532465133/photo/rv.jpg?s=612x612&w=0&k=20&c=5giHEFqCKYn3Tdvshhfy5K-vpHxicLb0mnsXtYVubog=",
          imageAlt: "RV Slide-Out Repair",
        },
        {
          title: "Electrical & Plumbing",
          description: "Systems repair for safe, reliable RV living.",
          imageSrc: "https://media.istockphoto.com/id/1285065830/photo/two-caravans-on-one-parking-place.jpg?s=612x612&w=0&k=20&c=UOOemr4Py3RCAR_2NrK9evYWZht5xGP_yMpoLZRHmlY=",
          imageAlt: "RV Electrical Repair",
        },
        {
          title: "Mobile Service",
          description: "Onsite repairs at your location or campsite.",
          imageSrc: "https://media.istockphoto.com/id/1328710367/photo/international-journalists-covering-the-news-press-van-broadcast-live.jpg?s=612x612&w=0&k=20&c=ZtlImqhK0cckDiNIspVXqVfE0coKCZVcByxJZeyhSoU=",
          imageAlt: "Mobile RV Repair",
        },
      ],
      otherServicesTitle: "Also Offering",
      otherServicesList: [
        "RV Inspection Services",
        "Brake & Bearing Service",
        "Appliance Repairs",
        "Trailer & Horse Trailer Upgrades",
      ],
    },
    sectionD: {
      aboutTitle: "About Us",
      aboutImage: {
        src: "https://media.istockphoto.com/id/184673927/photo/rv-on-a-camping-site.jpg?s=612x612&w=0&k=20&c=ceTzpG5wsLDnCoA696RjR1R-T9SaxFuIFyARNzkOPuM=",
        alt: "Goldsmiths RV Repair Team",
      },
      aboutText: [
        "Founded in 2023, Goldsmiths RV Repair LLC is a licensed, insured RV and trailer service provider in Tavares, FL.",
        "Led by owner Luke Goldsmith, we provide thorough inspections, mobile visits, and expert diagnostics for your recreational vehicle.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "Goldsmiths RV Repair Logo",
      businessName: "Goldsmiths RV Repair",
      contact: {
        phone: "4073942658",
        phoneLabel: "(407) 394‑2658",
        email: "goldsmithsrvrepairs@gmail.com",
        website: "https://goldsmithsrvrepairs.com/",
        address: "31106 Industry Drive, Tavares, FL 32778",
      },
      socialMedia: {
        facebook: "https://www.facebook.com/p/Goldsmiths-rv-repairs-llc-61552429275151/",
        instagram: null,
        twitter: null,
        linkedin: null,
        youtube: null,
      },
    },
    sectionF: {
      address: "31106 Industry Drive, Tavares, FL 32778",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3052.0!2d-81.685!3d28.804!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88e762bfedbb4a1b%3A0xabcdef1234567890!2s31106+Industry+Dr%2C+Tavares%2C+FL+32778!5e0!3m2!1sen!2sus!4v1718710000000!5m2!1sen!2sus",
    },
  },
};

export default config;
